import { defaultGuid } from '@equifinance/shared';
import { ProductLoanDetails } from './Products';

export const defaultProductLoanDetails: ProductLoanDetails = {
  id: defaultGuid,
  dirtyCount: 0,
  updateCount: 0,
  warnings: {},
  errors: {},
  loanDetails: {
    estimatedRedemptionAmount: 0,
    fees: {
      AdviceFee: {
        fee: 0,
        id: defaultGuid,
        isAddToLoan: false,
      },
      BrokerFee: {
        fee: 0,
        id: defaultGuid,
        isAddToLoan: false,
      },
      FeesToBePaidUpFront: {
        fee: 0,
        id: defaultGuid,
        isAddToLoan: false,
      },
      LenderFee: {
        fee: 0,
        id: defaultGuid,
        isAddToLoan: false,
      },
      ValuationFee: {
        fee: 0,
        id: defaultGuid,
        isAddToLoan: false,
      },
    },
    grossLoanAmount: 0,
    id: defaultGuid,
    isConsolidateExistingLoan: false,
    isExistingCustomer: false,
    loanAmount: 0,
    loanPurpose: [],
    loanPurposeDetails: '',
    outstandingCurrentBalance: 0,
    repaymentType: 'CapitalAndRepaymentOnly',
    term: 0,
  },
  productsResultDigest: null,
  property: {
    amountOfDiscount: 0,
    bedrooms: 0,
    constructionType: 'SystemBuilt',
    dateOfPurchase: '',
    estimatedPropertyValue: 0,
    floorsInBlock: 0,
    id: defaultGuid,
    isExCouncil: false,
    isParking: false,
    isPropertyAboveCommercialPremises: false,
    isRtbPurchase: false,
    isUpdateWithMonthlyGroundRent: false,
    isUpdateWithMonthlyServiceCharge: false,
    livingRooms: 0,
    monthlyGroundRent: 0,
    monthlyServiceCharge: 0,
    passesValuationCriteria: false,
    propertyType: 'ConvertedFlatMaisonette',
    propertyValue: 0,
    propertyValueType: 'BasedOnAvm',
    purchasePrice: 0,
    purchasingTheFullShareWithThisLoanAdvance: false,
    remainingLease: 0,
    tenure: 'Leasehold',
    wasBoughtThroughSharedOwnershipOrHelpToBuy: false,
  },
};
